import { createSlice } from '@reduxjs/toolkit'
import { getMyAllBetsKeno, getMyBetsKeno, placedBetKenoGame } from './kenoGame.thunk'
import { DEFAULT_PAGE_CALLS } from '../GameTheme/KenoGame/keno.constants'
import { plus } from 'number-precision'

const initialState = {
  placedBetData: null,
  betLock: false,
  betLoading: false,
  betSuccess: false,
  myBetsData: {
    count: 0,
    rows: []
  },
  myBetsLoading: false,
  myAllBetsData: {
    count: 0,
    rows: []
  },
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0
}

const {
  actions: {
    setBetLock,
    appendMyBetsKeno,
    resetPlacedBetData,
    setKenoGameWins,
    setKenoGameLosses,
    setKenoGameProfit,
    setKenoGameWagered,
    resetLiveStats
  },
  reducer
} = createSlice({
  name: 'kenoGame',
  initialState,
  reducers: {
    resetPlacedBetData: (state) => {
      return {
        ...state,
        placedBetData: initialState.placedBetData
      }
    },
    appendMyBetsKeno: (state, action) => {
      const { payload } = action
      const { nextServerSeedHash, ...data } = payload.placeBetData || { nextServerSeedHash: '', data: {} }
      if (nextServerSeedHash) {
        const myBetsDataRows = [data, ...state.myBetsData?.rows]
        const myAllBetsData = [data, ...state.myAllBetsData?.rows]
        if (myBetsDataRows.length > DEFAULT_PAGE_CALLS) {
          myBetsDataRows.pop()
        }
        if (myAllBetsData.length > 15) {
          myAllBetsData.pop()
        }
        return {
          ...state,
          myBetsData: {
            count: state.myBetsData?.count + 1,
            rows: myBetsDataRows
          },
          myAllBetsData: {
            count: state.myAllBetsData?.count + 1,
            rows: myAllBetsData
          }
        }
      }
      return state
    },
    setKenoGameWins: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setKenoGameLosses: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setKenoGameProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, (action.payload).toFixed(2))
      }
    },
    setKenoGameWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, (action.payload).toFixed(2))
      }
    },
    resetLiveStats: (state, action) => {
      return {
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placedBetKenoGame.pending, (state) => {
        return {
          ...state,
          betLock: true,
          placedBetData: initialState.placedBetData,
          betLoading: true,
          betSuccess: false
        }
      })
      .addCase(placedBetKenoGame.fulfilled, (state, action) => {
        return {
          ...state,
          placedBetData: action.payload,
          betLoading: false,
          betLock: false,
          betSuccess: true
        }
      })
      .addCase(placedBetKenoGame.rejected, (state) => {
        return {
          ...state,
          betLock: false,
          betLoading: false,
          betSuccess: false
        }
      })
      .addCase(getMyBetsKeno.pending, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: true
        }
      })
      .addCase(getMyBetsKeno.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload?.data?.data,
          myBetsLoading: false
        }
      })
      .addCase(getMyAllBetsKeno.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true
        }
      })
      .addCase(getMyAllBetsKeno.fulfilled, (state, action) => {
        return {
          ...state,
          myAllBetsData: action.payload,
          myBetsLoading: false
        }
      })
  }
})

export {
  setBetLock,
  appendMyBetsKeno,
  resetPlacedBetData,
  setKenoGameWins,
  setKenoGameLosses,
  setKenoGameProfit,
  setKenoGameWagered,
  resetLiveStats
}

export default reducer
